import React, { useEffect, useMemo, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../_redux/periode-kurban/periodeKurbanAction';
import * as uiHelpers from '../PeriodeKurbanUIHelpers';
import { currencyFormatter } from '../../../../../../../_metronic/_helpers';


import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
} from '../../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../../_metronic/_partials/controls';
import { usePeriodeKurbanUIContext } from '../PeriodeKurbanUIContext';
import { RoleChecker } from '../../../../../../RoleChecker';
import PeriodeKurbanStatusModal from '../periode-kurban-status-dialog/PeriodeKurbanStatusModal';
// import { ToastContainer } from 'react-toastify';

const PeriodeKurbanTable = (props) => {
    // PeriodeKurban UI Context
    const periodeKurbanUIContext = usePeriodeKurbanUIContext();
    const periodeKurbanUIProps = useMemo(() => {
        return {
            queryParams: periodeKurbanUIContext.queryParams,
            setQueryParams: periodeKurbanUIContext.setQueryParams,
            openEditPeriodeKurbanPage: periodeKurbanUIContext.openEditPeriodeKurbanPage,
        };
    }, [periodeKurbanUIContext]);


    // modal untuk change status
    const [show, setShow] = useState(false);
    // data set active untuk modal
    const [data, setData] = useState(null)

    const handleClose = () => {
        setShow(false)
        setData(null)
    };
    const handleShow = (row) => {
        setData(row)
        setShow(true)
    };


    // Getting curret state of periodeKurban list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.periodeKurbans }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading } = currentState;

    const dispatch = useDispatch();
    useEffect(() => {

        //Requset ke Branch Action
        dispatch(actions.fetchPeriodeKurbans(periodeKurbanUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [periodeKurbanUIProps.queryParams, dispatch]);

    const allowEdit = RoleChecker('Edit', 'periode_kurban')

    // Table columns
    const columns = [
        {
            dataField: 'name',
            text: 'Periode',
            // sortCaret: sortCaret,
        },
        {
            dataField: 'kurban_number_prefix',
            text: 'Nomor Prefix Kurban',
            // sortCaret: sortCaret,
        },
        {
            dataField: 'target_sapi',
            text: "Target Sapi"
        },
        {
            dataField: 'target_kambing',
            text: "Target Kambing"
        },
        {
            dataField: 'target_17_sapi',
            text: "Target 1/7 Sapi"
        },
        {
            dataField: 'target_fr_sapi',
            text: "Target Sapi Perorang"
        },
        {
            dataField: 'target_fr_kambing',
            text: "Target Kambing Perorang"
        },
        {
            dataField: 'target_fr_17_sapi',
            text: "Target 1/7 Sapi Perorang"
        },
        {
            dataField: 'is_active',
            text: 'Status',
            formatter: (cell, row) => {
                switch (cell) {
                    case true:
                        return <span class="badge badge-success">Aktif</span>
                    case false:
                        return <span class="badge badge-warning">Non-Aktif</span>
                    default:
                        break;
                }
            }
            // sortCaret: sortCaret,
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditPeriodeKurbanPage: periodeKurbanUIProps.openEditPeriodeKurbanPage,
                allowEdit,
                handleShow
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: periodeKurbanUIProps.queryParams.pageSize,
        page: periodeKurbanUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    periodeKurbanUIProps.setQueryParams,
                                )}
                                // selectRow={getSelectRow({
                                //   entities,
                                //   ids: productsUIProps.ids,
                                //   setIds: productsUIProps.setIds,
                                // })}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
            <PeriodeKurbanStatusModal show={show} data={data} handleClose={handleClose} />
        </>
    );
};

export default PeriodeKurbanTable;
